import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import '@angular/common/locales/global/hu';
import { environment } from '@szebit-app/environment';
import { UAParser } from 'ua-parser-js';

console.log('version: ', environment.version);

const parser = UAParser(window.navigator.userAgent);
const browser = parser.browser.name;
const os = parser.os.name;

const browserName = browser?.toLowerCase() ?? 'Ismeretlen böngésző';
const osName = os?.toLowerCase() ?? 'Ismeretlen OS';
const osVersion = parser.os?.version?.toLowerCase() ?? 'Ismeretlen verzió';

console.log({ browserName, osName, osVersion });

// Fix: bfcache
window.addEventListener('pageshow', event => {
  if (event.persisted) {
    // amikor back gombbal ternek vissza az app-ba akkor reload
    window.location.reload();
  }
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
